<app-fil-ariane-v2></app-fil-ariane-v2>
<div class="maincontainer background-color pb-4">
  <div class="mt-4">
    <app-hotels-add-form></app-hotels-add-form>
  </div>
</div>